var map = {
	"./editorBaseApi": [
		3059
	],
	"./editorBaseApi.js": [
		3059
	],
	"./editorSimpleWorker": [
		735
	],
	"./editorSimpleWorker.js": [
		735
	],
	"./editorWorker": [
		304
	],
	"./editorWorker.js": [
		304
	],
	"./editorWorkerHost": [
		6358
	],
	"./editorWorkerHost.js": [
		6358
	],
	"./findSectionHeaders": [
		9307
	],
	"./findSectionHeaders.js": [
		9307
	],
	"./getIconClasses": [
		8148
	],
	"./getIconClasses.js": [
		8148
	],
	"./languageFeatureDebounce": [
		2060
	],
	"./languageFeatureDebounce.js": [
		2060
	],
	"./languageFeatures": [
		2230
	],
	"./languageFeatures.js": [
		2230
	],
	"./languageFeaturesService": [
		1197
	],
	"./languageFeaturesService.js": [
		1197
	],
	"./languageService": [
		3930
	],
	"./languageService.js": [
		3930
	],
	"./languagesAssociations": [
		5996
	],
	"./languagesAssociations.js": [
		5996
	],
	"./languagesRegistry": [
		6995
	],
	"./languagesRegistry.js": [
		6995
	],
	"./markerDecorations": [
		886
	],
	"./markerDecorations.js": [
		886
	],
	"./markerDecorationsService": [
		11
	],
	"./markerDecorationsService.js": [
		11
	],
	"./model": [
		4830
	],
	"./model.js": [
		4830
	],
	"./modelService": [
		931
	],
	"./modelService.js": [
		931
	],
	"./resolverService": [
		7042
	],
	"./resolverService.js": [
		7042
	],
	"./semanticTokensDto": [
		9376
	],
	"./semanticTokensDto.js": [
		9376
	],
	"./semanticTokensProviderStyling": [
		9520
	],
	"./semanticTokensProviderStyling.js": [
		9520
	],
	"./semanticTokensStyling": [
		2891
	],
	"./semanticTokensStyling.js": [
		2891
	],
	"./semanticTokensStylingService": [
		5767
	],
	"./semanticTokensStylingService.js": [
		5767
	],
	"./textModelSync/textModelSync.impl": [
		5456
	],
	"./textModelSync/textModelSync.impl.js": [
		5456
	],
	"./textModelSync/textModelSync.protocol": [
		5628,
		628
	],
	"./textModelSync/textModelSync.protocol.js": [
		5628,
		628
	],
	"./textResourceConfiguration": [
		1504
	],
	"./textResourceConfiguration.js": [
		1504
	],
	"./treeSitterParserService": [
		5320
	],
	"./treeSitterParserService.js": [
		5320
	],
	"./treeViewsDnd": [
		2603
	],
	"./treeViewsDnd.js": [
		2603
	],
	"./treeViewsDndService": [
		6756
	],
	"./treeViewsDndService.js": [
		6756
	],
	"./unicodeTextModelHighlighter": [
		9887
	],
	"./unicodeTextModelHighlighter.js": [
		9887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9204;
module.exports = webpackAsyncContext;